export enum ECoworkingSpecification {
  FLOOR = 'coworkingFloor',
  CAPACITY = 'coworkingCapacity',
  ACCESS = 'coworkingAccess',
}
